function isEnvTrue(key) {
  return process.env[key] === 'true';
}

module.exports = { isEnvTrue };
